module.exports = __webpack_public_path__ + "a61a7f4dde279e5b1861c278955e488d.png";